import { useState, useEffect, useContext } from 'react';
import { Hub } from 'aws-amplify/utils';
import { getCurrentUser } from 'aws-amplify/auth';

import { LOG_ACTIVE, SIGN_IN } from '../constants/actions';
import { StoreContext } from '../store';

const useAuthorize = () => {
  const { dispatch } = useContext(StoreContext);
  const [error, setError] = useState('');

  useEffect(() => {
    if (! dispatch) { return () => {}; }

    const handleAuthEvent = async ({ event, data }) => {
      switch (event) {
        case 'signedIn':
        case 'signInWithRedirect':
          // In v6, we need to get the user after sign-in event
          try {
            const user = await getCurrentUser();

            dispatch({ type: SIGN_IN, payload: { user } });
            dispatch({ type: LOG_ACTIVE, payload: { time: Date.now() } });
            setError('');
          } catch (err) {
            setError(`Sign In Failure: ${err.message}`);
          }
          break;
        case 'signInWithRedirect_failure':
        case 'tokenRefresh_failure':
          setError(`Sign In Failure: ${data?.message || 'Unknown error'}`);
          break;
        case 'signedOut':
          setError('');
          break;
        default:
          console.warn(event); // eslint-disable-line no-console
          setError('Unsupported auth event');
      }
    };

    const hubListenerCancel = Hub.listen('auth', ({ payload }) => handleAuthEvent(payload));

    return () => hubListenerCancel();
  }, [dispatch]);

  return error;
};

export default useAuthorize;
